// extracted by mini-css-extract-plugin
export var carrierTab = "_4w-0";
export var carrierTabActive = "_4w-1 _4w-0";
export var carrierTabInactive = "_4w-2 _4w-0";
export var carrierTabLabel = "_4w-3";
export var carrierTabLabelActive = "_4w-4 _4w-3";
export var carrierTabLabelInactive = "_4w-5 _4w-3";
export var carrierTabPercentage = "_4w-6";
export var carrierTabPercentageActive = "_4w-7 _4w-6";
export var carrierTabPercentageInactive = "_4w-8 _4w-6";
export var carrierTabWinnable = "_4w-9";
export var carrierTabWinnableActive = "_4w-a _4w-9";
export var carrierTabWinnableInactive = "_4w-b _4w-9";
export var comparisonContainer = "_4w-d";
export var missingRateButton = "_4w-n";
export var missingRateButtonActive = "_4w-o _4w-n";
export var missingRateButtonInactive = "_4w-p _4w-n";
export var missingRateButtonLabel = "_4w-q";
export var missingRateButtonLabelActive = "_4w-r _4w-q";
export var missingRateButtonLabelInactive = "_4w-s _4w-q";
export var sidebar = "_4w-c";
export var strategyButton = "_4w-e";
export var strategyButtonActive = "_4w-f _4w-e";
export var strategyButtonDescription = "_4w-k";
export var strategyButtonDescriptionActive = "_4w-l _4w-k";
export var strategyButtonDescriptionInactive = "_4w-m _4w-k";
export var strategyButtonInactive = "_4w-g _4w-e";
export var strategyButtonLabel = "_4w-h";
export var strategyButtonLabelActive = "_4w-i _4w-h";
export var strategyButtonLabelInactive = "_4w-j _4w-h";
export var unitToggleButton = "_4w-t";
export var unitToggleButtonActive = "_4w-u _4w-t";
export var unitToggleButtonInactive = "_4w-v _4w-t";
export var unitToggleButtonLabel = "_4w-w";
export var unitToggleButtonLabelActive = "_4w-x _4w-w";
export var unitToggleButtonLabelInactive = "_4w-y _4w-w";